import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { SharedService } from 'src/app/_shared/shared.service';
import { RepService } from '../services/rep.service';
import { IStationMapPoint } from '../_shared/station-map/station-map.component';

@Component({
  selector: 'app-stations-map',
  templateUrl: './stations-map.component.html'
})
export class StationsMapComponent implements OnInit {
  points: IStationMapPoint[] = [];
  userLocation: { lat: number; lng: number } | null = null;
  geolocationDenied = false;
  dataReady = false;
  selectedStation: any = null;

  constructor(
    private repService: RepService,
    private router: Router,
    private shared: SharedService
  ) {}

  async ngOnInit(): Promise<void> {
    await this.loadStations();
    this.requestUserLocation();
  }

  async loadStations(): Promise<void> {
    try {
      const locations: any[] = await this.repService.getLocations() || [];
      const pts: IStationMapPoint[] = [];
      for (const loc of locations) {
        for (const st of (loc.stations || [])) {
          if (st.latitude == null || st.longitude == null) continue;
          pts.push({
            id_station: st.id_station,
            name: st.name,
            latitude: Number(st.latitude),
            longitude: Number(st.longitude),
            popupHtml: this.buildPopup(loc, st)
          });
          // Uchovat referenci na lokaci pro výběr
          (pts[pts.length - 1] as any).__loc = loc;
          (pts[pts.length - 1] as any).__st = st;
        }
      }
      this.points = pts;
      this.dataReady = true;
    } catch (error) {
      this.shared.reportError(error, 'Error loading stations for map');
    }
  }

  private buildPopup(loc: any, st: any): string {
    const safe = (s: string) => (s || '').replace(/[&<>"']/g, c => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]!));
    const addr = [loc.street, loc.city].filter(Boolean).map(safe).join(', ');
    return `<strong>${safe(st.name)}</strong><br>
      <small>${safe(loc.name)}${addr ? ' — ' + addr : ''}</small><br>
      <small>${st.capacity_kwh || '?'} kWh</small>`;
  }

  requestUserLocation(): void {
    if (!navigator.geolocation) {
      this.geolocationDenied = true;
      return;
    }
    navigator.geolocation.getCurrentPosition(
      pos => {
        this.userLocation = { lat: pos.coords.latitude, lng: pos.coords.longitude };
      },
      () => { this.geolocationDenied = true; },
      { enableHighAccuracy: false, timeout: 8000, maximumAge: 60000 }
    );
  }

  onStationClick(p: IStationMapPoint): void {
    this.selectedStation = p;
  }

  reserveSelected(): void {
    if (this.selectedStation?.id_station) {
      this.router.navigate(['/reservations/new'], { queryParams: { id_station: this.selectedStation.id_station } });
    }
  }
}
